import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';

import { getResponseValidator } from '@ui/legacy-lib';
import { SearchFacade } from 'landlord/search/service/search.facade';
import { ProspectsSearchResult } from 'landlord/search/models/search-result.model';

import * as fromSearchModalActions from './search.actions';

@Injectable()
export class SearchEffects {
  private actions$ = inject(Actions<fromSearchModalActions.SearchActions>);
  private searchFacade = inject(SearchFacade);

  searchProspects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromSearchModalActions.FETCH_SEARCH_RESULTS),
      switchMap((action: fromSearchModalActions.FetchSearchResults) =>
        this.searchFacade.searchProspects(action.searchTerm).pipe(
          tap(getResponseValidator<ProspectsSearchResult>()),
          map(result => result.data.landlordFindPropertySearcher),
          map(
            result =>
              new fromSearchModalActions.FetchSearchResultsSuccess(
                result.nodes,
                result.page
              )
          ),
          catchError(() => {
            return of(
              new fromSearchModalActions.FetchSearchResultsFail(
                new Error('FETCH_SEARCH_RESULT_FAIL')
              )
            );
          })
        )
      )
    )
  );
}
